import React, { useState } from 'react';
import Dropzone from 'react-dropzone';
import {
  DropzoneCustomHeightWrap,
  DropzoneHere,
  DropzoneImage,
  DropzoneImageDelete,
  DropzoneImageName,
  DropzoneInput,
  DropzoneSingleWrap,
} from './DropzoneElements';
import styled from 'styled-components';
import { colorText } from '@/utils/palette';

const DropZoneField = ({ customHeight = false, name, onChange, label, error, helperText }) => {
  const [files, setFiles] = useState();

  const onDrop = (file) => {
    setFiles(
      file.map((fl) =>
        Object.assign(fl, {
          preview: URL.createObjectURL(fl),
        }),
      ),
    );
    onChange(
      file.map((fl) =>
        Object.assign(fl, {
          preview: URL.createObjectURL(fl),
        }),
      ),
    );
  };
  const removeFile = (index, e) => {
    e.preventDefault();
    if (files == '' || files?.length == 1) {
      setFiles(null);
      onChange(null);
    } else {
      setFiles((prev) => prev.filter((val, i) => i !== index));
      onChange(files.filter((val, i) => i !== index));
    }
  };

  const DropzoneWrap = customHeight ? DropzoneCustomHeightWrap : DropzoneSingleWrap;

  return (
    <>
      {label && <Label error={error}>{label}</Label>}
      <DropzoneWrap>
        <Dropzone
          name={name}
          multiple={false}
          onDrop={(fileToUpload) => {
            onDrop(fileToUpload);
          }}
        >
          {({ getRootProps, getInputProps }) => (
            <DropzoneInput {...getRootProps()}>
              {(!files || files.length === 0) && (
                <DropzoneHere>
                  <span className='lnr lnr-upload' /> Drop file here to upload
                </DropzoneHere>
              )}
              <input {...getInputProps()} />
            </DropzoneInput>
          )}
        </Dropzone>
        {files && Array.isArray(files) && files.length > 0 && (
          <DropzoneImage>
            <img
              src={files[0].preview}
              alt={files[0].name}
              loading='lazy'
            />
            <DropzoneImageName>{files[0].name}</DropzoneImageName>
            <DropzoneImageDelete
              type='button'
              onClick={(e) => removeFile(0, e)}
            >
              Remove
            </DropzoneImageDelete>
          </DropzoneImage>
        )}
      </DropzoneWrap>
      {helperText && <HelperText>{helperText}</HelperText>}
      {error && <ErrorMessage>{error}</ErrorMessage>}
    </>
  );
};

export default DropZoneField;

const Label = styled.div`
  font-size: 12px;
  margin-top: 5px;
  color: ${(props) => (props.error ? 'red' : colorText)};
`;

const HelperText = styled.div`
  font-size: 12px;
  margin-top: 5px;
  color: ${colorText};
`;

const ErrorMessage = styled.div`
  color: red;
  margin-bottom: 20px;
  font-size: 12px;
`;
